// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ButtonDetails_buttonContainer__mTdOm"};